
// language managment
export const SET_LANGUAGE = 'SET_LANGUAGE';